import { render, staticRenderFns } from "./FetcherProductShow.vue?vue&type=template&id=6b797332&"
import script from "./FetcherProductShow.vue?vue&type=script&lang=js&"
export * from "./FetcherProductShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports